export const FONTS = ``; /* Fonts loaded via <link> in index.html — no duplicate @import needed */

export const THEMES = {
  dark: {
    // ── Backgrounds ──────────────────────────────────────────────────────────
    bg:             "#0a141f",
    bgElevated:     "#121c27",
    bgNav:          "rgba(10,20,31,0.82)",
    bgPanel:        "#16202b",
    bgPanelHead:    "#212b36",
    bgInput:        "#050f19",
    bgChip:         "#212b36",
    bgChipActive:   "rgba(240,90,65,0.12)",
    bgSettingGrp:   "#16202b",
    bgSearchInp:    "#050f19",
    bgCsvPrev:      "#16202b",
    bgToggle:       "#212b36",
    bgFooter:       "#050f19",
    bgCard:         "#16202b",
    bgCardHover:    "#2c3641",

    // ── Borders ──────────────────────────────────────────────────────────────
    border:         "rgba(90,65,60,0.15)",
    borderHover:    "rgba(90,65,60,0.30)",
    borderActive:   "#F05A41",
    borderError:    "rgba(229,72,77,0.30)",
    borderChip:     "rgba(90,65,60,0.20)",
    borderChipActive: "#F05A41",
    borderStrong:   "rgba(255,255,255,0.10)",

    // ── Text ─────────────────────────────────────────────────────────────────
    text:           "#d9e3f2",
    textPrimary:    "#d9e3f2",
    textDim:        "#94a3b8",
    textSecondary:  "#94a3b8",
    textMuted:      "#64748b",
    textLabel:      "#64748b",
    textAccent:     "#F05A41",
    accent:         "#F05A41",
    accent2:        "#D8A056",
    textChip:       "#94a3b8",
    textChipActive: "#d9e3f2",

    // ── Gradients ────────────────────────────────────────────────────────────
    gradient:        "linear-gradient(135deg, #F05A41 0%, #D8A056 100%)",
    gradientSoft:    "linear-gradient(135deg, rgba(240,90,65,0.15) 0%, rgba(216,160,86,0.10) 100%)",
    accentGrad:      "linear-gradient(135deg, #F05A41 0%, #D8A056 100%)",
    accentMain:      "#F05A41",
    accentGradGreen: "linear-gradient(135deg, #0e7a4a, #16a361)",
    accentGradAmber: "linear-gradient(135deg, #D8A056 0%, #F05A41 100%)",

    // ── Controls ─────────────────────────────────────────────────────────────
    toggleOn:   "#F05A41",
    dotBlue:    "#F05A41",
    dotGreen:   "#22c55e",
    dotAmber:   "#D8A056",
    logoBg:     "linear-gradient(135deg, #F05A41 0%, #D8A056 100%)",

    // ── Status ───────────────────────────────────────────────────────────────
    statusOk:   "#22c55e",
    statusErr:  "#E5484D",
    statusIdle: "#6C7885",

    // ── Table ────────────────────────────────────────────────────────────────
    tdNumber:      "#F05A41",
    tdBoolTrue:    "#22c55e",
    tdBoolFalse:   "#E5484D",
    tdNull:        "#6C7885",
    rowStatsMuted: "#6C7885",
    rowStatsVal:   "#A8B2BD",
    chevron:       "#6C7885",
    scrollThumb:   "rgba(255,255,255,0.08)",
    thBg:          "#121c27",
    trHover:       "#16202b",

    // ── Layout ───────────────────────────────────────────────────────────────
    heroGrad:  "linear-gradient(160deg, #121c27 0%, #0a141f 55%)",
    statBg:    "#16202b",
    dragBg:    "#121c27",
    dragBorder:"rgba(90,65,60,0.25)",
    dragText:  "#6C7885",

    // ── Footer ───────────────────────────────────────────────────────────────
    footerText:      "#6C7885",
    footerLink:      "#A8B2BD",
    footerLinkHover: "#F05A41",
    footerBorder:    "rgba(255,255,255,0.06)",

    // ── Tags / Pills ─────────────────────────────────────────────────────────
    tagBg:     "rgba(240,90,65,0.12)",
    tagText:   "#F05A41",
    tagBorder: "rgba(240,90,65,0.30)",

    pillBlue:        "rgba(240,90,65,0.12)",
    pillBlueText:    "#F05A41",
    pillBlueBorder:  "rgba(240,90,65,0.30)",
    pillGreen:       "rgba(34,197,94,0.10)",
    pillGreenText:   "#22c55e",
    pillGreenBorder: "rgba(34,197,94,0.25)",
    pillAmber:       "rgba(216,160,86,0.12)",
    pillAmberText:   "#D8A056",
    pillAmberBorder: "rgba(216,160,86,0.30)",
    pillRed:         "rgba(229,72,77,0.12)",
    pillRedText:     "#E5484D",
    pillRedBorder:   "rgba(229,72,77,0.25)",

    // ── Theme toggle ─────────────────────────────────────────────────────────
    sunMoon:  "☾",
    themeLbl: "Dark Mode",
  },

  light: {
    // ── Backgrounds ──────────────────────────────────────────────────────────
    bg:             "#FBFBFB",
    bgElevated:     "#FFFFFF",
    bgNav:          "rgba(251,251,251,0.93)",
    bgPanel:        "#F4F5F7",
    bgPanelHead:    "#FFFFFF",
    bgInput:        "#FFFFFF",
    bgChip:         "#F4F5F7",
    bgChipActive:   "rgba(240,90,65,0.08)",
    bgSettingGrp:   "#F4F5F7",
    bgSearchInp:    "#FFFFFF",
    bgCsvPrev:      "#F4F5F7",
    bgToggle:       "#E8EAF0",
    bgFooter:       "#F0F1F5",
    bgCard:         "#FFFFFF",
    bgCardHover:    "#FFF5F3",

    // ── Borders ──────────────────────────────────────────────────────────────
    border:         "rgba(60,70,82,0.12)",
    borderHover:    "rgba(60,70,82,0.22)",
    borderActive:   "#F05A41",
    borderError:    "rgba(229,72,77,0.30)",
    borderChip:     "rgba(60,70,82,0.12)",
    borderChipActive: "#F05A41",
    borderStrong:   "rgba(60,70,82,0.22)",

    // ── Text ─────────────────────────────────────────────────────────────────
    text:           "#3C4652",
    textPrimary:    "#3C4652",
    textDim:        "#5A6573",
    textSecondary:  "#5A6573",
    textMuted:      "#8A95A3",
    textLabel:      "#8A95A3",
    textAccent:     "#D94A33",
    accent:         "#D94A33",
    accent2:        "#B87800",
    textChip:       "#5A6573",
    textChipActive: "#D94A33",

    // ── Gradients ────────────────────────────────────────────────────────────
    gradient:        "linear-gradient(135deg, #F05A41 0%, #D8A056 100%)",
    gradientSoft:    "linear-gradient(135deg, rgba(240,90,65,0.08) 0%, rgba(216,160,86,0.06) 100%)",
    accentGrad:      "linear-gradient(135deg, #F05A41 0%, #D8A056 100%)",
    accentMain:      "#F05A41",
    accentGradGreen: "linear-gradient(135deg, #15803d, #16a34a)",
    accentGradAmber: "linear-gradient(135deg, #D8A056 0%, #F05A41 100%)",

    // ── Controls ─────────────────────────────────────────────────────────────
    toggleOn:   "#F05A41",
    dotBlue:    "#D94A33",
    dotGreen:   "#16a34a",
    dotAmber:   "#B87800",
    logoBg:     "linear-gradient(135deg, #F05A41 0%, #D8A056 100%)",

    // ── Status ───────────────────────────────────────────────────────────────
    statusOk:   "#16a34a",
    statusErr:  "#dc2626",
    statusIdle: "#8A95A3",

    // ── Table ────────────────────────────────────────────────────────────────
    tdNumber:      "#D94A33",
    tdBoolTrue:    "#16a34a",
    tdBoolFalse:   "#dc2626",
    tdNull:        "#8A95A3",
    rowStatsMuted: "#8A95A3",
    rowStatsVal:   "#5A6573",
    chevron:       "#8A95A3",
    scrollThumb:   "rgba(60,70,82,0.15)",
    thBg:          "#F4F5F7",
    trHover:       "#FFF5F3",

    // ── Layout ───────────────────────────────────────────────────────────────
    heroGrad:  "linear-gradient(160deg, rgba(240,90,65,0.06) 0%, #FBFBFB 55%)",
    statBg:    "#FFFFFF",
    dragBg:    "#F4F5F7",
    dragBorder:"rgba(60,70,82,0.22)",
    dragText:  "#8A95A3",

    // ── Footer ───────────────────────────────────────────────────────────────
    footerText:      "#8A95A3",
    footerLink:      "#5A6573",
    footerLinkHover: "#F05A41",
    footerBorder:    "rgba(60,70,82,0.10)",

    // ── Tags / Pills ─────────────────────────────────────────────────────────
    tagBg:     "rgba(240,90,65,0.08)",
    tagText:   "#D94A33",
    tagBorder: "rgba(240,90,65,0.25)",

    pillBlue:        "rgba(240,90,65,0.08)",
    pillBlueText:    "#D94A33",
    pillBlueBorder:  "rgba(240,90,65,0.20)",
    pillGreen:       "#dcfce7",
    pillGreenText:   "#16a34a",
    pillGreenBorder: "rgba(22,163,74,0.30)",
    pillAmber:       "rgba(216,160,86,0.10)",
    pillAmberText:   "#B87800",
    pillAmberBorder: "rgba(216,160,86,0.25)",
    pillRed:         "#fee2e2",
    pillRedText:     "#dc2626",
    pillRedBorder:   "rgba(220,38,38,0.25)",

    // ── Theme toggle ─────────────────────────────────────────────────────────
    sunMoon:  "☀",
    themeLbl: "Light Mode",
  },
};

export function makeBaseStyles(t) {
  return `
* { box-sizing:border-box; margin:0; padding:0; }
html { scroll-behavior:smooth; }
body { font-family:'Plus Jakarta Sans',sans-serif; background:${t.bg}; min-height:100vh; color:${t.textPrimary}; transition:background 0.3s,color 0.3s; font-size:15px; }

/* ── SKIP TO CONTENT ── */
.skip-link {
  position:absolute; top:-100px; left:1rem; z-index:9999;
  background:${t.accentGrad}; color:#fff; padding:8px 18px;
  border-radius:8px; font-size:14px; font-weight:600; text-decoration:none;
  transition:top 0.15s;
}
.skip-link:focus { top:1rem; }

/* ── NAVBAR (legacy, kept for compatibility) ── */
.navbar { position:sticky; top:0; z-index:100; background:${t.bgNav}; border-bottom:1px solid ${t.border}; backdrop-filter:blur(16px); -webkit-backdrop-filter:blur(16px); }
.navbar-inner { max-width:1200px; margin:0 auto; padding:0 1.5rem; display:flex; align-items:center; justify-content:space-between; height:60px; gap:12px; }
.nav-brand { display:flex; align-items:center; gap:10px; text-decoration:none; cursor:pointer; flex-shrink:0; }
.nav-brand-icon { width:34px; height:34px; background:${t.logoBg}; border-radius:9px; display:flex; align-items:center; justify-content:center; font-family:'JetBrains Mono',monospace; font-size:11px; font-weight:600; color:#fff; letter-spacing:-0.5px; flex-shrink:0; }
.nav-brand-name { font-size:16px; font-weight:700; color:${t.textPrimary}; letter-spacing:-0.3px; }
.nav-brand-sub { font-size:10px; color:${t.textMuted}; font-family:'JetBrains Mono',monospace; }

/* ── HOME HERO ── */
.home-hero { background:${t.heroGrad}; border-bottom:1px solid ${t.border}; padding:5rem 1.5rem 3.5rem; position:relative; overflow:hidden; }
.home-hero::before,.home-hero::after {
  content:""; position:absolute; border-radius:50%; pointer-events:none;
  animation:blob-drift 20s ease-in-out infinite;
}
.home-hero::before {
  width:600px; height:600px; top:-150px; right:-150px;
  background:radial-gradient(circle, rgba(240,90,65,0.08) 0%, transparent 70%);
  animation-delay:0s;
}
.home-hero::after {
  width:500px; height:500px; bottom:-100px; left:-100px;
  background:radial-gradient(circle, rgba(216,160,86,0.08) 0%, transparent 70%);
  animation-delay:-10s;
}
@keyframes blob-drift {
  0%,100% { transform:translate(0,0) scale(1); }
  33%      { transform:translate(30px,-20px) scale(1.05); }
  66%      { transform:translate(-20px,15px) scale(0.97); }
}
.home-hero-inner { max-width:720px; margin:0 auto; text-align:center; position:relative; z-index:1; }
.home-hero h1 { font-size:clamp(28px,5vw,48px); font-weight:800; color:${t.textPrimary}; margin-bottom:16px; line-height:1.1; letter-spacing:-0.02em; }
.home-hero h1 em { font-style:normal; background:${t.gradient}; -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
.home-hero p { font-size:clamp(14px,2vw,17px); color:${t.textSecondary}; line-height:1.7; margin-bottom:2.5rem; max-width:520px; margin-left:auto; margin-right:auto; font-weight:400; }
.hero-ctas { display:flex; gap:12px; justify-content:center; flex-wrap:wrap; margin-bottom:2rem; }
.hero-trust { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:2.5rem; }
.hero-trust-item { display:flex; align-items:center; gap:6px; font-size:13px; color:${t.textMuted}; font-weight:500; }
.hero-trust-item svg { color:${t.statusOk}; flex-shrink:0; }
.home-tool-cards { display:grid; grid-template-columns:repeat(auto-fit,minmax(190px,1fr)); gap:12px; max-width:740px; margin:0 auto; }
.home-tool-card {
  background:${t.bgCard}; border:1px solid ${t.border}; border-radius:16px; padding:1.25rem;
  cursor:pointer; transition:border-color 0.2s, transform 0.2s, box-shadow 0.2s;
  text-align:left; position:relative; overflow:hidden;
}
.home-tool-card::after {
  content:""; position:absolute; inset:0; background:${t.gradient};
  opacity:0; transition:opacity 0.2s;
  border-radius:16px;
}
.home-tool-card:hover { border-color:${t.borderActive}; background:${t.bgCardHover}; transform:translateY(-2px); box-shadow:0 8px 24px rgba(240,90,65,0.12); }
.home-tool-card-icon { font-size:22px; margin-bottom:10px; display:block; position:relative; z-index:1; }
.home-tool-card-name { font-size:14px; font-weight:600; color:${t.textPrimary}; margin-bottom:4px; position:relative; z-index:1; }
.home-tool-card-desc { font-size:12px; color:${t.textSecondary}; line-height:1.5; position:relative; z-index:1; }
.home-tool-card-arrow { font-size:12px; color:${t.textMuted}; margin-top:8px; display:block; transition:transform 0.2s; position:relative; z-index:1; }
.home-tool-card:hover .home-tool-card-arrow { transform:translateX(4px); color:${t.textAccent}; }

/* ── FEATURE STRIP ── */
.feature-strip { padding:2.5rem 1.5rem; border-bottom:1px solid ${t.border}; }
.feature-strip-inner { max-width:900px; margin:0 auto; display:grid; grid-template-columns:repeat(auto-fit,minmax(180px,1fr)); gap:12px; }
.feature-card {
  background:${t.gradientSoft}; border:1px solid ${t.border}; border-radius:14px;
  padding:1.25rem 1rem; text-align:center;
  transition:transform 0.2s, box-shadow 0.2s;
}
.feature-card:hover { transform:translateY(-2px); box-shadow:0 6px 20px rgba(240,90,65,0.10); }
.feature-card-icon { font-size:24px; margin-bottom:8px; }
.feature-card-title { font-size:14px; font-weight:600; color:${t.textPrimary}; margin-bottom:4px; }
.feature-card-desc { font-size:12px; color:${t.textMuted}; line-height:1.5; }

/* ── SECTION HEADER ── */
.section-header { text-align:center; margin-bottom:2rem; }
.section-header h2 { font-size:clamp(20px,3vw,28px); font-weight:700; color:${t.textPrimary}; margin-bottom:8px; letter-spacing:-0.02em; }
.section-header p { font-size:14px; color:${t.textSecondary}; max-width:480px; margin:0 auto; }
.gradient-underline { width:48px; height:2px; background:${t.gradient}; margin:8px auto 0; border-radius:2px; }

/* ── TOOLS GRID SECTION ── */
.tools-section { padding:3rem 1.5rem; }
.tools-section-inner { max-width:1140px; margin:0 auto; }
.tools-group { margin-bottom:2.5rem; }
.tools-group-label { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:0.1em; color:${t.textMuted}; margin-bottom:12px; display:flex; align-items:center; gap:8px; }
.tools-group-label::after { content:""; flex:1; height:1px; background:${t.border}; }
.tools-group-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:10px; }
.tool-grid-card {
  background:${t.bgCard}; border:1px solid ${t.border}; border-radius:14px;
  padding:1rem 1.1rem; cursor:pointer; display:flex; align-items:flex-start; gap:10px;
  transition:border-color 0.2s, transform 0.2s, box-shadow 0.2s;
  position:relative; overflow:hidden;
}
.tool-grid-card::before {
  content:""; position:absolute; top:0; left:-100%; width:100%; height:100%;
  background:linear-gradient(90deg, transparent, rgba(240,90,65,0.06), transparent);
  transition:left 0.4s;
}
.tool-grid-card:hover::before { left:100%; }
.tool-grid-card:hover { border-color:${t.borderActive}; transform:translateY(-1px); box-shadow:0 4px 16px rgba(240,90,65,0.10); }
.tool-grid-card-icon { width:36px; height:36px; border-radius:10px; background:${t.gradientSoft}; border:1px solid ${t.border}; display:flex; align-items:center; justify-content:center; font-size:16px; flex-shrink:0; }
.tool-grid-card-body { flex:1; min-width:0; }
.tool-grid-card-name { font-size:13px; font-weight:600; color:${t.textPrimary}; margin-bottom:3px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.tool-grid-card-desc { font-size:11px; color:${t.textMuted}; line-height:1.4; }
.tool-grid-card-arrow { font-size:12px; color:${t.textMuted}; flex-shrink:0; margin-top:2px; transition:transform 0.2s, color 0.2s; }
.tool-grid-card:hover .tool-grid-card-arrow { transform:translateX(3px); color:${t.textAccent}; }

/* ── TOOL PAGE LAYOUT ── */
.tool-hero { background:${t.heroGrad}; border-bottom:1px solid ${t.border}; padding:2.25rem 1.5rem 2rem; }
.tool-hero-inner { max-width:1200px; margin:0 auto; display:flex; align-items:center; justify-content:space-between; gap:1rem; flex-wrap:wrap; }
.tool-hero-left h1,.tool-hero-left h2 { font-size:clamp(18px,3vw,26px); font-weight:700; color:${t.textPrimary}; margin-bottom:6px; letter-spacing:-0.01em; }
.tool-hero-left h1::after,.tool-hero-left h2::after { content:""; display:block; width:48px; height:2px; background:${t.gradient}; border-radius:2px; margin-top:8px; }
.tool-hero-left p { font-size:13px; color:${t.textSecondary}; line-height:1.6; }
.tool-hero-stats { display:flex; gap:1.5rem; flex-wrap:wrap; }
.tool-stat { text-align:center; }
.tool-stat-val { font-size:18px; font-weight:700; color:${t.textAccent}; font-family:'JetBrains Mono',monospace; }
.tool-stat-lbl { font-size:10px; color:${t.textMuted}; text-transform:uppercase; letter-spacing:0.06em; }

/* ── MAIN WRAPPER ── */
.tool-main { max-width:1200px; margin:0 auto; padding:1.5rem 1.5rem 3rem; }

/* ── PANELS ── */
.panel { background:${t.bgPanel}; border:1px solid ${t.border}; border-radius:14px; overflow:hidden; transition:border-color 0.2s,background 0.3s; }
.panel:hover { border-color:${t.borderHover}; }
.panel.error-panel  { border-color:${t.borderError}; }
.panel.active-panel { border-color:${t.borderActive}; }
.panel-header { display:flex; align-items:center; justify-content:space-between; padding:10px 14px; border-bottom:1px solid ${t.border}; background:${t.bgPanelHead}; }
.panel-title { display:flex; align-items:center; gap:8px; font-size:11px; font-weight:600; color:${t.textAccent}; text-transform:uppercase; letter-spacing:0.09em; }
.panel-action { display:flex; gap:6px; align-items:center; }

/* ── PILL TAB BAR ── */
.pill-tabs { display:flex; gap:6px; padding:12px 16px; flex-wrap:wrap; }
.pill-tab {
  display:inline-flex; align-items:center; gap:6px;
  padding:7px 16px; border-radius:10px; font-size:12px; font-weight:700;
  cursor:pointer; border:1px solid ${t.border}; background:${t.bgPanelHead};
  color:${t.textSecondary}; transition:all 0.15s; font-family:'Plus Jakarta Sans',sans-serif;
  white-space:nowrap; letter-spacing:0.01em; text-transform:uppercase;
  active:scale-95;
}
.pill-tab:hover { background:${t.bgCardHover}; color:${t.textPrimary}; }
.pill-tab.active { background:${t.gradient}; border-color:transparent; color:#fff; box-shadow:0 4px 14px rgba(240,90,65,0.25); }
.pill-tab-bar { border-bottom:1px solid ${t.border}; background:${t.bgPanelHead}; }

/* ── DOTS ── */
.dot { width:6px; height:6px; border-radius:50%; flex-shrink:0; }
.dot-blue  { background:${t.dotBlue}; }
.dot-green { background:${t.dotGreen}; animation:pulse-dot 2s infinite; }
.dot-amber { background:${t.dotAmber}; }
.dot-red   { background:#E5484D; }

/* ── BUTTONS ── */
.btn-sm {
  background:none; border:1px solid ${t.border}; border-radius:8px;
  padding:4px 11px; font-size:11px; color:${t.textMuted}; cursor:pointer;
  font-family:'JetBrains Mono',monospace; transition:all 0.15s;
  min-height:30px; min-width:30px;
}
.btn-sm:hover { background:${t.bgChipActive}; color:${t.textAccent}; border-color:${t.borderActive}; }
.btn-primary {
  display:inline-flex; align-items:center; gap:8px;
  background:${t.gradient}; border:none; border-radius:10px;
  padding:10px 22px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:700;
  color:#fff; cursor:pointer; transition:all 0.15s;
  box-shadow:0 4px 14px rgba(240,90,65,0.20);
}
.btn-primary:hover { transform:translateY(-1px); box-shadow:0 8px 24px rgba(240,90,65,0.35); }
.btn-primary:active { transform:scale(0.98); }
.btn-primary:disabled { opacity:0.35; cursor:not-allowed; transform:none; box-shadow:none; }
.btn-secondary {
  display:inline-flex; align-items:center; gap:7px;
  background:${t.bgPanel}; border:1px solid ${t.border}; border-radius:10px;
  padding:10px 16px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px;
  color:${t.textSecondary}; cursor:pointer; transition:all 0.15s;
}
.btn-secondary:hover { background:${t.bgChipActive}; border-color:${t.borderActive}; color:${t.textAccent}; }
.btn-secondary.success { color:${t.statusOk}; border-color:${t.statusOk}; }
.btn-secondary:disabled { opacity:0.35; cursor:not-allowed; }
.btn-green {
  display:inline-flex; align-items:center; gap:8px;
  background:${t.accentGradGreen}; border:none; border-radius:10px;
  padding:10px 22px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:500;
  color:#fff; cursor:pointer; transition:all 0.15s;
}
.btn-green:hover { transform:translateY(-1px); box-shadow:0 4px 18px rgba(22,163,97,0.3); }
.btn-green:active { transform:scale(0.98); }
.btn-ghost {
  display:inline-flex; align-items:center; gap:8px;
  background:transparent; border:1px solid ${t.border}; border-radius:10px;
  padding:10px 22px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:500;
  color:${t.textPrimary}; cursor:pointer; transition:all 0.15s;
}
.btn-ghost:hover { border-color:${t.borderActive}; color:${t.textAccent}; background:${t.bgChipActive}; }

/* ── INPUTS ── */
.inp {
  background:${t.bgInput}; border:1px solid ${t.border}; border-radius:8px;
  padding:8px 12px; font-size:13px; color:${t.textPrimary};
  font-family:'Plus Jakarta Sans',sans-serif; outline:none; transition:border-color 0.15s, box-shadow 0.15s; width:100%;
}
.inp:focus { border-color:${t.borderActive}; box-shadow:0 0 0 3px rgba(240,90,65,0.12); }
.inp::placeholder { color:${t.textMuted}; }
.inp-mono { font-family:'JetBrains Mono',monospace; font-size:12px; }
select.inp { cursor:pointer; }

/* ── FOCUS VISIBLE ── */
:focus-visible {
  outline:2px solid ${t.borderActive};
  outline-offset:2px;
}
button:focus-visible, a:focus-visible {
  outline:2px solid ${t.borderActive};
  outline-offset:2px;
  border-radius:4px;
}

/* ── TOGGLE ── */
.toggle-wrap { display:flex; align-items:center; gap:8px; cursor:pointer; user-select:none; font-size:13px; color:${t.textLabel}; }
.toggle { width:32px; height:18px; background:${t.bgToggle}; border-radius:9px; position:relative; transition:background 0.2s; flex-shrink:0; }
.toggle.on { background:${t.toggleOn}; }
.toggle-thumb { width:12px; height:12px; background:#fff; border-radius:50%; position:absolute; top:3px; left:3px; transition:left 0.2s; }
.toggle.on .toggle-thumb { left:17px; }

/* ── CHIPS ── */
.chip { display:inline-flex; align-items:center; gap:5px; background:${t.bgChip}; border:1px solid ${t.borderChip}; border-radius:20px; padding:4px 11px; font-size:11px; font-family:'JetBrains Mono',monospace; color:${t.textChip}; cursor:pointer; transition:all 0.15s; user-select:none; }
.chip:hover { border-color:${t.borderActive}; color:${t.textAccent}; }
.chip.active { background:${t.bgChipActive}; border-color:${t.borderChipActive}; color:${t.textChipActive}; }
.chip .check { width:12px; height:12px; border-radius:50%; background:${t.accentMain}; display:flex; align-items:center; justify-content:center; font-size:8px; color:#fff; flex-shrink:0; }

/* ── TABLE ── */
.table-wrap { overflow-x:auto; max-height:340px; overflow-y:auto; scrollbar-width:thin; scrollbar-color:${t.scrollThumb} transparent; }
.table-wrap::-webkit-scrollbar { width:5px; height:5px; }
.table-wrap::-webkit-scrollbar-thumb { background:${t.scrollThumb}; border-radius:4px; }
.data-table { width:100%; border-collapse:collapse; font-size:12px; font-family:'JetBrains Mono',monospace; }
.data-table th { background:${t.thBg}; color:${t.textAccent}; padding:7px 12px; text-align:left; font-weight:600; font-size:10px; text-transform:uppercase; letter-spacing:0.08em; border-bottom:1px solid ${t.border}; position:sticky; top:0; z-index:1; white-space:nowrap; cursor:pointer; user-select:none; }
.data-table th:hover { color:${t.textPrimary}; }
.data-table td { padding:7px 12px; border-bottom:1px solid ${t.border}; color:${t.textSecondary}; white-space:nowrap; max-width:220px; overflow:hidden; text-overflow:ellipsis; }
.data-table tr:nth-child(even) td { background:${t.bgPanelHead}; }
.data-table tr:hover td { background:${t.trHover}; }

/* ── STATUS ── */
.status-bar { padding:7px 14px; border-top:1px solid ${t.border}; font-size:11px; font-family:'JetBrains Mono',monospace; display:flex; align-items:center; gap:6px; flex-wrap:wrap; }
.status-bar.ok   { color:${t.statusOk}; }
.status-bar.err  { color:${t.statusErr}; }
.status-bar.idle { color:${t.textMuted}; }

/* ── SECTION ── */
.section-label { font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:0.08em; color:${t.textMuted}; margin-bottom:8px; }
.section-gap { margin-bottom:1rem; }

/* ── GRID UTILS ── */
.grid-2 { display:grid; grid-template-columns:1fr 1fr; gap:1rem; }
.grid-3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:1rem; }
@media(max-width:700px){ .grid-2,.grid-3{ grid-template-columns:1fr; } }

/* ── EMPTY STATE ── */
.empty-state { display:flex; flex-direction:column; align-items:center; justify-content:center; height:200px; color:${t.textMuted}; font-size:12px; font-family:'JetBrains Mono',monospace; gap:8px; }
.empty-icon-box { width:44px; height:44px; border-radius:12px; border:1px dashed ${t.border}; display:flex; align-items:center; justify-content:center; font-size:20px; }

/* ── PILL BADGES ── */
.pill { display:inline-flex; align-items:center; border-radius:20px; padding:3px 10px; font-size:10px; font-family:'JetBrains Mono',monospace; font-weight:500; }
.pill-blue  { background:${t.pillBlue};  color:${t.pillBlueText};  border:1px solid ${t.pillBlueBorder}; }
.pill-green { background:${t.pillGreen}; color:${t.pillGreenText}; border:1px solid ${t.pillGreenBorder}; }
.pill-amber { background:${t.pillAmber}; color:${t.pillAmberText}; border:1px solid ${t.pillAmberBorder}; }
.pill-red   { background:${t.pillRed};   color:${t.pillRedText};   border:1px solid ${t.pillRedBorder}; }

/* ── ON-PAGE SEO SECTION ── */
.tool-seo-section {
  max-width:1200px; margin:0 auto; padding:2.5rem 1.5rem 3rem;
  border-top:1px solid ${t.border};
}
.tool-seo-section h2 {
  font-size:18px; font-weight:700; color:${t.textPrimary}; margin-bottom:1rem;
  letter-spacing:-0.01em;
}
.tool-seo-section h3 {
  font-size:13px; font-weight:600; color:${t.textAccent}; margin-bottom:6px;
  text-transform:uppercase; letter-spacing:0.07em;
}
.tool-seo-section p { font-size:13px; color:${t.textSecondary}; line-height:1.7; margin-bottom:1rem; }
.tool-seo-section ul { padding-left:1.25rem; margin-bottom:1rem; }
.tool-seo-section ul li { font-size:13px; color:${t.textSecondary}; line-height:1.7; margin-bottom:4px; }
.tool-seo-section details { border:1px solid ${t.border}; border-radius:10px; margin-bottom:8px; overflow:hidden; }
.tool-seo-section summary {
  padding:12px 16px; cursor:pointer; font-size:13px; font-weight:600;
  color:${t.textPrimary}; background:${t.bgPanelHead}; list-style:none;
  display:flex; justify-content:space-between; align-items:center;
}
.tool-seo-section summary::-webkit-details-marker { display:none; }
.tool-seo-section summary::after { content:"﹢"; font-size:16px; color:${t.textMuted}; }
.tool-seo-section details[open] summary::after { content:"✕"; }
.tool-seo-section details > p { padding:12px 16px 14px; margin-bottom:0; background:${t.bgPanel}; }
.tool-seo-cols { display:grid; grid-template-columns:1fr 1fr 1fr; gap:1.5rem; margin-bottom:1.5rem; }
@media(max-width:700px){ .tool-seo-cols { grid-template-columns:1fr; } }

/* ── FOOTER ── */
.footer { background:${t.bgFooter}; padding:3rem 1.5rem 1.5rem; }
.footer-gradient-divider { height:2px; background:${t.gradient}; margin-bottom:3rem; border-radius:2px; max-width:80px; }
.footer-inner { max-width:1200px; margin:0 auto; display:grid; grid-template-columns:1.5fr 1fr 1fr; gap:2rem; align-items:start; margin-bottom:1.5rem; }
@media(max-width:640px){ .footer-inner{ grid-template-columns:1fr; gap:1.5rem; } }
.footer-brand { display:flex; align-items:center; gap:10px; margin-bottom:10px; }
.footer-brand-icon { width:30px; height:30px; background:${t.logoBg}; border-radius:7px; display:flex; align-items:center; justify-content:center; font-family:'JetBrains Mono',monospace; font-size:10px; font-weight:600; color:#fff; flex-shrink:0; }
.footer-brand-name { font-size:14px; font-weight:700; color:${t.textPrimary}; }
.footer-tagline { font-size:12px; color:${t.footerText}; line-height:1.7; }
.footer-links-title { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:0.1em; color:${t.textMuted}; margin-bottom:10px; }
.footer-links { display:flex; flex-direction:column; gap:7px; }
.footer-link { font-size:13px; color:${t.footerLink}; text-decoration:none; transition:color 0.15s; cursor:pointer; background:none; border:none; text-align:left; padding:0; font-family:'Plus Jakarta Sans',sans-serif; }
.footer-link:hover { color:${t.footerLinkHover}; }
.footer-bottom { max-width:1200px; margin:0 auto; padding-top:1.25rem; border-top:1px solid ${t.footerBorder}; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:8px; }
.footer-copy { font-size:12px; color:${t.footerText}; }
.footer-credit { display:flex; align-items:center; gap:6px; text-decoration:none; font-size:12px; color:${t.footerLink}; transition:color 0.15s; font-weight:500; }
.footer-credit:hover { color:${t.footerLinkHover}; }
.live-dot { width:6px; height:6px; border-radius:50%; background:${t.dotGreen}; animation:pulse-dot 2s infinite; }

/* ── ANIMATIONS ── */
@keyframes fade-up {
  from { opacity:0; transform:translateY(12px); }
  to   { opacity:1; transform:translateY(0); }
}
@keyframes fade-in {
  from { opacity:0; }
  to   { opacity:1; }
}
@keyframes pulse-dot {
  0%,100% { opacity:1; }
  50%      { opacity:0.35; }
}
@keyframes spin-slow {
  from { transform:rotate(0deg); }
  to   { transform:rotate(360deg); }
}
@keyframes slide-down {
  from { opacity:0; transform:translateY(-5px); }
  to   { opacity:1; transform:translateY(0); }
}

.fade-up { animation:fade-up 0.5s ease forwards; }
.fade-in { animation:fade-in 0.4s ease forwards; }
.slide-down { animation:slide-down 0.2s ease; }
.spin-slow  { animation:spin-slow 8s linear infinite; }

.d1{animation-delay:0.05s;opacity:0} .d2{animation-delay:0.10s;opacity:0}
.d3{animation-delay:0.15s;opacity:0} .d4{animation-delay:0.20s;opacity:0}
.d5{animation-delay:0.25s;opacity:0} .d6{animation-delay:0.30s;opacity:0}

/* ── REDUCED MOTION ── */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration:0.01ms !important;
    animation-iteration-count:1 !important;
    transition-duration:0.01ms !important;
  }
  .home-hero::before, .home-hero::after { animation:none; }
}
`;
}
